import Header from "./components/Header";
import PasswordField from "./components/PasswordField";
import React, {useState} from "react";
import {Button, Grid, IconButton, InputAdornment, TextField} from "@mui/material";
import axios from "axios";
import {API_URL} from "./config";
import {toast} from "react-toastify";
import {confirmAlert} from "react-confirm-alert";
import {useNavigate} from "react-router-dom";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import Footer from "./components/Footer";


export default function PasswordChange() {
    const [passwordErrorParent, setPasswordErrorParent] = useState(false);
    const [passwordParent, setPasswordParent] = useState('');
    const navigate= useNavigate();
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
     });

    const handleSubmit = () => {
        let doctor_id= localStorage.getItem('ac_id');
        let token = JSON.parse(localStorage.getItem("ac_auth_token"));

        axios.post(`${API_URL}/auth/change-password`, {
            id:doctor_id,
            current_password:values.password,
            new_password: passwordParent,
            confirm_new_password: passwordParent
        },{
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
            )
            .then(async function (response) {
                console.log(response.data.message);

                    toast.success("Güncelleme Başarılı. Tekrar giriş yapmanız için login sayfasına yönlendiriliyorsunuz.");

                    await localStorage.removeItem('token');
                    await localStorage.removeItem("name");
                    await localStorage.removeItem("permissions");
                    await localStorage.removeItem("department");

                    // Kullanıcıyı giriş sayfasına yönlendir
                    navigate('/');




            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data.detail);

            });
    }

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleClickShowConfirmPassword = () => {
        setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
    };
    const [passwordError, setPasswordError] = useState(null);

return (
    < >
    <Header />
        <div style={{margin: "2em"}}>
        <Grid container >
            <Grid  item md={3} xs={12} sm={4}>
                <label>Eski Şifre</label>

                <TextField
                    size="small"
                    name="password"
                    placeholder="Eski Şifre"
                    type={values.showPassword ? 'text' : 'password'}
                    fullWidth
                    variant="outlined"
                    value={values.password}
                    onChange={handleChange('password')}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClickShowPassword}>
                                    {values.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

            </Grid>
        </Grid>
        <Grid container>

            <Grid  item md={6} xs={12} sm={4}>

                <PasswordField setPasswordParent={setPasswordParent}
                               setPasswordErrorParent={setPasswordErrorParent}/>
            </Grid>

        </Grid>
        <p></p>
        <Grid container>
            <Grid md={3} xs={12} sm={3}>
                <Button disabled={passwordErrorParent} variant="contained" color={'success'}
                        style={{boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)'}} onClick={() => {
                    handleSubmit()
                }}> Kaydet</Button>

            </Grid>

            <Grid md={2} xs={12} sm={2}>

            </Grid>
        </Grid>
        </div>
        <Footer />

    </>
)

}
